'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  padding-top: 50px;\n  position: absolute;\n  z-index: 50;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0,0,0,0.5);\n  padding: 50px;\n  box-sizing: border-box;\n\n  .boring {\n    background: white;\n    width: 90%;\n    height: 1000px;\n    overflow-y: scroll;\n    padding: 40px;\n    margin: 0 auto;\n\n    h1 {\n      font-size: 30px;\n      margin: 20px 0;\n      font-weight: bold;\n      text-align: center;\n    }\n\n    h2 {\n      font-size: 25px;\n      margin: 20px 0;\n      font-weight: bold;\n      text-align: center;\n    }\n\n    p {\n      font-size: 20px;\n      margin: 10px 0;\n    }\n  }\n\n  .close {\n    text-align: center;\n    text-transform: uppercase;\n    width: 700px;\n    margin: 50px auto 0 auto;\n    background: ', ';\n    color: ', ';\n    padding: 30px 25px;\n    font-family: \'Roboto Bold\';\n    font-size: 45px;\n    cursor: pointer;\n    line-height: 48px;\n    border-radius: 10px;\n  }\n'], ['\n  padding-top: 50px;\n  position: absolute;\n  z-index: 50;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0,0,0,0.5);\n  padding: 50px;\n  box-sizing: border-box;\n\n  .boring {\n    background: white;\n    width: 90%;\n    height: 1000px;\n    overflow-y: scroll;\n    padding: 40px;\n    margin: 0 auto;\n\n    h1 {\n      font-size: 30px;\n      margin: 20px 0;\n      font-weight: bold;\n      text-align: center;\n    }\n\n    h2 {\n      font-size: 25px;\n      margin: 20px 0;\n      font-weight: bold;\n      text-align: center;\n    }\n\n    p {\n      font-size: 20px;\n      margin: 10px 0;\n    }\n  }\n\n  .close {\n    text-align: center;\n    text-transform: uppercase;\n    width: 700px;\n    margin: 50px auto 0 auto;\n    background: ', ';\n    color: ', ';\n    padding: 30px 25px;\n    font-family: \'Roboto Bold\';\n    font-size: 45px;\n    cursor: pointer;\n    line-height: 48px;\n    border-radius: 10px;\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _doohReactUtils = require('dooh-react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RawHTML = function () {
  function RawHTML() {
    _classCallCheck(this, RawHTML);
  }

  _createClass(RawHTML, [{
    key: 'create',
    value: function create(el, props) {
      el.innerHTML = props.html;
    }
  }]);

  return RawHTML;
}();

var Wrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.buttonBackgroundColor || '#FE0000';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.buttonTextColor || 'white';
});

var Terms = function Terms(_ref3) {
  var terms = _ref3.terms,
      onClose = _ref3.onClose;
  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(_doohReactUtils.NonReact, { className: 'boring', delegate: RawHTML, html: terms }),
    _react2.default.createElement(
      _doohReactUtils.Tap,
      { className: 'close', onTap: onClose },
      'U redu'
    )
  );
};

exports.default = Terms;


//////////////////
// WEBPACK FOOTER
// ./~/dooh-react-utils/dist/form/Terms.js
// module id = 140
// module chunks = 0